import {
  ExistingEquipmentFieldTooltipType,
  FilterTooltipType,
  OversizeRangeType,
  StructureTypeType,
  TemperatureDataType
} from 'data/types';
import { emptyApi } from './empty-api';

const dataApi = emptyApi.injectEndpoints({
  endpoints: (builder) => ({
    getBTULimits: builder.query<number[][], void>({
      query: () => 'btu-limits'
    }),
    getExistingEquipmentFieldTooltips: builder.query<
      ExistingEquipmentFieldTooltipType[],
      void
    >({
      query: () => 'existing-equipment-field-tooltips'
    }),
    getFilterTooltips: builder.query<FilterTooltipType[], void>({
      query: () => 'filter-tooltips'
    }),
    getOversizeRanges: builder.query<OversizeRangeType[], void>({
      query: () => 'oversize-ranges'
    }),
    getStructureTypes: builder.query<StructureTypeType[], void>({
      query: () => 'structure-types'
    }),
    getTemperatureData: builder.query<
      {
        temperatureData: TemperatureDataType[];
        avgMaxSnowDepth: number;
        elevation: number;
      },
      void
    >({
      query: () => 'temperature-data'
    })
  })
});

export const {
  useGetBTULimitsQuery,
  useGetExistingEquipmentFieldTooltipsQuery,
  useGetFilterTooltipsQuery,
  useGetOversizeRangesQuery,
  useGetStructureTypesQuery,
  useGetTemperatureDataQuery
} = dataApi;
